import React from "react";
import '../App.css'

const Error = () => {
  return (
    <div className="error-page">
      <div className="error-text">
        <h1>404 Error</h1>
        <p>The page you're looking for doesn't exist.</p>
      </div>
    </div>
  );
};

export default Error;
